import React from 'react';
import { bool, func, shape, string } from 'prop-types';

// Components
import { Box, Button, useTheme } from '@mui/material';

// Util
import { useUserRolePermissions } from 'hooks';
import { useNavigate, useParams } from 'react-router-dom';

// styles
import { cardButtonSelectStyles } from '../Card.styles';

const CardButtonSelect = ({
  listType,
  selfAuthorization,
  setDialogSelfAuthorization,
  setSelfAuthorizationDialogOpen,
}) => {
  const { isSubscriber } = useUserRolePermissions();
  // card information
  const { activeAuthorization } = selfAuthorization;
  const { active, extendedLoadingAllowed, extendedLoadingAccepted } = activeAuthorization || {};

  // styles:
  const theme = useTheme();

  const { currentAffiliateId, dataCompanyId } = useParams();
  const navigate = useNavigate();

  // extended loading button
  const extendedLoadingCopy = extendedLoadingAccepted ? 'Turn Off' : 'Turn On';
  const showExtendedLoadingCopy = extendedLoadingAllowed ? extendedLoadingCopy : 'Not Available';

  // activate button
  const activateButtonCopy = active ? 'Turn Off' : 'Turn On';

  const handleCardButtonClick = dialogType => {
    setSelfAuthorizationDialogOpen(dialogType);
    setDialogSelfAuthorization(selfAuthorization);
  };

  const getBackgroundColor = () => {
    if (isSubscriber && extendedLoadingAllowed && !extendedLoadingAccepted) {
      return 'surface.medium';
    }
    return 'transparent';
  };

  const getBorderColor = () => {
    if (isSubscriber) {
      if (
        (!extendedLoadingAllowed && !extendedLoadingAccepted) ||
        (extendedLoadingAllowed && extendedLoadingAccepted)
      ) {
        return 'graphic.light';
      }
      return 'transparent';
    }
    return 'yellow.main';
  };

  return (
    <>
      {listType === 'baseProducts' && (
        <Box
          alignItems="center"
          bgcolor={getBackgroundColor()}
          border="1px solid"
          borderColor={getBorderColor()}
          borderRadius="4px"
          display="flex"
          flexDirection="column"
          pb={0.5}
          pt={1.5}
          px={0}
          sx={cardButtonSelectStyles}
          width="100%"
        >
          Extended Loading
          {isSubscriber ? (
            active ? (
              <Button
                disabled={!extendedLoadingAllowed}
                onClick={() =>
                  handleCardButtonClick(
                    extendedLoadingAccepted
                      ? 'deactivateExtendedLoading'
                      : 'activateExtendedLoading'
                  )
                }
                sx={{
                  ...theme.typography.subtitle2,
                  ':disabled': {
                    color: 'text.secondary',
                  },
                  color: 'secondary.main',
                }}
                variant="text"
              >
                {showExtendedLoadingCopy}
              </Button>
            ) : (
              <Button
                disabled
                sx={{
                  ...theme.typography.subtitle2,
                  ':disabled': {
                    color: 'text.secondary',
                  },
                  color: 'secondary.main',
                }}
                variant="text"
              >
                Not Allowed
              </Button>
            )
          ) : (
            <Button
              onClick={() => {
                navigate(`/affiliate/${currentAffiliateId}/${dataCompanyId}/swift-plus`);
              }}
              sx={{ color: 'secondary.main' }}
              variant="text"
            >
              Enroll in Swift+ to Enable
            </Button>
          )}
        </Box>
      )}

      <Button
        onClick={() => {
          handleCardButtonClick(!active ? 'activateProduct' : 'deactivateProduct');
        }}
        sx={{
          gridColumn: '1 / 3',
          mb: 0.5,
          mt: 1,
          mx: 0,
        }}
        variant={active ? 'outlined' : 'contained'}
      >
        {activateButtonCopy}
      </Button>
    </>
  );
};

CardButtonSelect.propTypes = {
  listType: string.isRequired,
  selfAuthorization: shape({
    activeAuthorization: shape({
      active: bool,
      extendedLoadingAccepted: bool,
      extendedLoadingAllowed: bool,
    }),
  }).isRequired,
  setDialogSelfAuthorization: func.isRequired,
  setSelfAuthorizationDialogOpen: func.isRequired,
};

export default CardButtonSelect;
